const DocumentsFileItem = (props) => {
    const {
        name, link, size, type
    } = props;

    return `
        <div class="documents-certificate-item">
            <a href="${link}" class="documents-certificate-item__title" target="_blank">${name}</a>
            <span class="documents-certificate-item__type">${type}, ${size}</span>
        </div>
    `;
};

export default DocumentsFileItem;
